import HeaderActionBar from '../HeaderActionBar/HeaderActionBar'
import classes from './Reports.module.css'
import StudentTracking from '../../../lms-shared/StudentStatistics/StudentTracking'
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';




const Reports = () => {
    const { studyGroupId } = useParams()
    const { user } = useSelector(state => state.auth);
    const { direction, texts } = useSelector((state) => state.translate);

    return (
        <>
            <HeaderActionBar />
            <div>
                <h1 className={classes.ReportsTitle}>{texts.myAchievements}</h1>
                <div className={`${classes[direction]} ${classes.ReportsWarrper}`}>
                    <div className={classes.Reportscontainer}>
                        {user && user.id && <StudentTracking studyGroupId={studyGroupId} userId={user.id} id={studyGroupId}></StudentTracking>}
                    </div>
                </div>
            </div>
        </>
    )
}
export default Reports